import React from 'react'
import Icon from './base/Icon'
import { overlay, pushup } from './LoadingOverlay.css'

export interface LoadingOverlayProps {
  uploading: boolean
  children?: React.ReactElement
}

const LoadingOverlay: React.SFC<LoadingOverlayProps> = ({ uploading, children }) => {
  if (!uploading) return <React.Fragment>{children}</React.Fragment>

  return (
    <React.Fragment>
      <div className={overlay}>
        <div>
          <Icon name="spinner" color="#3688DF" spin size="50" />
        </div>
        <h3>We&apos;re uploading your paper...</h3>
        <div className={pushup} />
      </div>
      {children}
    </React.Fragment>
  )
}

export default LoadingOverlay
